import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import Person, { PersonFormSend } from "@/interfaces/Person";
import api from "../api";

export const peopleApi = api.injectEndpoints({
  endpoints: (builds) => ({
    getPeople: builds.query<IPaginateResponse<Person>, IFilters>({
      query: (params) => ({
        url: "/people",
        params,
      }),
      providesTags: (result, _error, _arg) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "People" as const,
                id,
              })),
              { type: "People", id: "LIST" },
            ]
          : [{ type: "People", id: "LIST" }],
    }),
    getPerson: builds.query<Person, string>({
      query: (id) => `/people/${id}`,
      providesTags: (_result, _error, id) => [{ type: "People", id }],
    }),
    storePerson: builds.mutation<Person, PersonFormSend>({
      query: (body) => ({
        url: `/people`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_, __, { companyId }) => [
        { type: "People", id: "LIST" },
        { type: "CompanyPeople", companyId, id: "LIST" },
      ],
    }),
    updatePerson: builds.mutation<
      Person,
      [string, Partial<PersonFormSend>, string | undefined]
    >({
      query: ([id, body]) => ({
        url: `/people/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, [id, , companyId]) => [
        { type: "People", id },
        ...(companyId
          ? [{ type: "CompanyPeople" as const, companyId, id: "LIST" }]
          : []),
      ],
    }),
    deletePerson: builds.mutation<void, string>({
      query: (id) => ({
        url: `/people/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "People", id: "LIST" }],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetPeopleQuery,
  useGetPersonQuery,
  useUpdatePersonMutation,
  useDeletePersonMutation,
  useStorePersonMutation,
} = peopleApi;
